import * as React from 'react';
import { LazyLoadComponentWrapper } from '../lazy-load/lazy-load-component-wrapper';
import { BillingCardLoadingIndicator } from './new-card-loading-indicator';
import { ICardProps } from '@components/cards/card-wrapper';

const DashboardCard = React.lazy(() => import(/* webpackChunkName:"billing-card" */'./index'));

type IIncidentManagementCardOwnProps = ICardProps;
const cardTitle: string = 'Billing';
const NewBillingCard = (props: IIncidentManagementCardOwnProps) => (
    <LazyLoadComponentWrapper
        fallback={<BillingCardLoadingIndicator error={false} cardTitle={cardTitle} />}
        errorIndicator={<BillingCardLoadingIndicator error={true} cardTitle={cardTitle} />}>
        <DashboardCard {...props} />
    </LazyLoadComponentWrapper>
);

export default NewBillingCard;
